import axios from 'axios';
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';

import { BACKEND_SERVER_URL } from '../../../http/http-config';
import DateInput from '../Common-Components/DateInput';
import FileInput from '../Common-Components/FileInput';
import Input from '../Common-Components/Input';
import TinyEditor from '../Common-Components/TinyEditor';
import '../Course/Course.css';
// import { fetchBlogData, formateBlogData } from './BlogHelper';


const CUET_AboutsModal = forwardRef((props, ref) => {
    let initialFormData = {
        Title: '',
        Description: '',
        DisplayOrder: 0,
    }
    const [modalBox, setModalBox] = useState(false);
    const [formData, setFormData] = useState(initialFormData);




    useImperativeHandle(ref, () => ({
        openModal(item) {
            setModalBox(true);
            if (item) {
                setFormData(item);
            } else {
                setFormData(initialFormData);
            }

        }
    }));
    const handleChange = (name, value) => {
        setFormData((formData) => (
            { ...formData, [name]: value }
        ));
    };
    //console.log(formData)
    const handleSubmitBlog = () => {
        axios.post(BACKEND_SERVER_URL + (formData.Sn ? `/cuet/updateAbout/${formData.Sn}` : '/cuet/createAbout'), formData).then((response) => {
            setFormData(initialFormData)
            toast.success(response.data.message)
            props.setBlogsLoading(!props.loadBlogs)
            setModalBox(false);
        }).catch((error) => {
            toast.error(error.response.data.message)
            console.log(error)
        })

    }
    useEffect(() => {
        if (!modalBox) {
            setFormData(initialFormData);
        }
    }, [modalBox]);

    return (
        <>
            <Modal className="" show={modalBox} onHide={setModalBox} dialogClassName="custom-modal-width" backdrop="static"
                keyboard={false} >
                <Modal.Header>
                    <Modal.Title>{formData?.Sn ? 'Update About' : 'Create About'}</Modal.Title>
                    <Button variant="" className="btn-close" onClick={() => setModalBox(false)}></Button>
                </Modal.Header>
                <Modal.Body>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <Input handleChangeCallBack={handleChange} labelName="Title" inputType="text" inputValue={formData?.Title} inputName='Title' divSizes={[2, 10]} />
                                </div>
                            </div>
                            <div className="col-12 mt-3">
                                <div className="d-flex">
                                    <Input handleChangeCallBack={handleChange} labelName="Display Order" inputType="number" inputValue={formData?.DisplayOrder} inputName='DisplayOrder' divSizes={[2, 10]} />
                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <TinyEditor handleChangeCallBack={handleChange} labelName="Description" inputValue={formData?.Description} inputName='Description' />
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger light" className='btn-sm' onClick={() => setModalBox(false)}>Close</Button>
                    <Button variant="primary " className='btn-sm ' onClick={handleSubmitBlog}>{formData?.Sn ? 'Update' : 'Create'}</Button>
                </Modal.Footer>
            </Modal>


        </>
    )
})
export default CUET_AboutsModal;